import { SET_WEIGHERS, SET_WEIGHERS_LOADED } from './actions.js'

export function weighers(state = [], action) {
	switch (action.type) {
		case SET_WEIGHERS:
			return action.data
		default:
			return state;
	}
}

export function weighersLoaded(state = false, action) {
	switch (action.type) {
		case SET_WEIGHERS_LOADED:
			return action.data
		default:
			return state;
	}
}
